import ClientAgent from '../clientAgent'
import {CloudProject} from './CloudProject'

export class CloudProjectList {
  /**
   * @type {CloudProject[]}
   * @private
   */
  _list = []
  _ca = null

  /**
   * @returns {Promise<void>}
   */
  async loadProjectList () {
    let response = await this.ca.makeRequest('openStack/servisne/getAllCloudProjectsWithUsers', {})
    this._list = []
    response.projects.forEach((item) => {
      let project = new CloudProject()
      project.loadBasicProjectData(
        item.idTerminationPoint,
        item.name,
        item.owner,
        item.maintainer,
        item.cloudUsers,
        item.siteId,
        item.siteName
      )
      this._list.push(project)
    })
  }

  /**
   * @param {CloudUser} user
   * @param {number} idTerminationPoint
   */
  addUserToProject (user, idTerminationPoint) {
    this._list.forEach((project) => {
      if (project.idTerminationPoint === idTerminationPoint) {
        project.users.addUserToList(user)
      }
    })
  }

  /**
   * @returns array<CloudProject>|null
   */
  get list () {
    return this._list
  }

  set list (value) {
    this._list = value
  }

  get ca () {
    if (this._ca === null) {
      this._ca = new ClientAgent()
    }
    return this._ca
  }

  set ca (value) {
    this._ca = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/T2Cloud/CloudProjectList.js